import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "components/pages/Auth/Login";
import SignUp from "components/pages/Auth/SignUp";
import ForgotPassword from "components/pages/Auth/ForgotPassword";
import Message from "components/pages/Auth/Message";
import Home from "components/pages/Home";
import { layoutContext } from "context/layoutContext";
import ChangePassword from "components/pages/Auth/ChangePassword";
import { UserProfile } from "components/pages/Profile/UserProfile";
import HealthPlanIndex from "components/pages/HealthPlan/HealthPlanIndex";
import LabsIndex from "components/pages/Labs/LabsIndex";
import LabRequestPdf from "components/pages/Labs/LabRequestPdf";
import AppointmentsIndex from "../pages/Appointments/AppointmentsIndex";
import CreateAppointment from "../pages/Appointments/CreateAppointment";

const Content = ({ no_background }) => {
  const layoutState = useContext(layoutContext);
  const { origin } = layoutState;

  if (!origin) return null;

  return (
    <div className={`basepage__content ${no_background && "white-background"}`}>
      <Routes>
        <Route
            path={`/${origin}/my-appointments/create/`}
            element={<CreateAppointment />}
        />
        <Route
            path={`/${origin}/my-appointments/`}
            element={<AppointmentsIndex />}
        />
        <Route
          path={`/${origin}/my-labs/pdf/`}
          element={<LabRequestPdf />}
        />
        <Route path={`/${origin}/my-labs/`} element={<LabsIndex />} />
        <Route
          path={`/${origin}/my-health-plan/`}
          element={<HealthPlanIndex />}
        />
        <Route
          path={`/${origin}/change-password/`}
          element={<ChangePassword />}
        />
        <Route path={`/${origin}/login/`} element={<Login />} />
        <Route path={`/${origin}/signup/`} element={<SignUp />} />
        <Route path={`/${origin}/profile/`} element={<UserProfile />} />
        <Route
          path={`/${origin}/update-password/`}
          element={<Message message="change__password__message" />}
        />
        <Route
          path={`/${origin}/post-register/`}
          element={<Message message="postregister__message" />}
        />
        <Route
          path={`/${origin}/forgot-password/`}
          element={<ForgotPassword />}
        />
        <Route
          path={`/${origin}/change-mail/`}
          element={<Message message="change__mail_message" />}
        />
        <Route path={`/${origin}/`} element={<Home />} />
        <Route
          path="*"
          element={<Navigate to={{ pathname: `/${origin}/login` }} />}
        />
      </Routes>
    </div>
  );
};

export default Content;